import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Signin from './components/Signin';
import UserHomePage from './components/UserHomePage';
import './Css/App.css';

const App = () => {
    // Initialize auth state from localStorage, checking both role and token
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        const token = localStorage.getItem('token');
        const role = localStorage.getItem('role');
        return !!(token && role); // Convert to boolean - true if both exist
    });
    
    // Keep track of user role separately
    const [userRole, setUserRole] = useState(() => {
        return localStorage.getItem('role');
    });

    // Effect to check authentication status when component mounts or when storage changes
    useEffect(() => {
        const checkAuthStatus = () => {
            const token = localStorage.getItem('token');
            const role = localStorage.getItem('role');
            setIsAuthenticated(!!(token && role));
            setUserRole(role);
        };

        // Check auth status initially
        checkAuthStatus();

        // Listen for storage events (in case localStorage changes in another tab)
        window.addEventListener('storage', checkAuthStatus);
        
        return () => {
            window.removeEventListener('storage', checkAuthStatus);
        };
    }, []);

    const handleLogin = (userData) => {
        setIsAuthenticated(true);
        setUserRole(userData.role);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('username');
        setIsAuthenticated(false);
        setUserRole(null);
    };

    return (
        <Router>
            <Routes>
                <Route 
                    path="/signin" 
                    element={isAuthenticated ? <Navigate to="/invoices-homepage" /> : <Signin onLogin={handleLogin} />} 
                />
                <Route
                    path="/invoices-homepage"
                    element={isAuthenticated ? <UserHomePage userRole={userRole} onLogout={handleLogout} /> : <Navigate to="/signin" />}
                />
                <Route path="/" element={<Navigate to={isAuthenticated ? "/invoices-homepage" : "/signin"} />} />
                {/* Catch all other routes and redirect to appropriate page based on auth status */}
                <Route path="*" element={<Navigate to={isAuthenticated ? "/invoices-homepage" : "/signin"} />} />
            </Routes>
        </Router>
    );
};

export default App;